var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "studentList" } }, [
            _vm._v("学生列表")
          ]),
          _c("el-menu-item", { attrs: { index: "capabilityLabel" } }, [
            _vm._v("能力标签")
          ])
        ],
        1
      ),
      _c("student-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "studentList",
            expression: "activeIndex == 'studentList'"
          }
        ],
        ref: "studentList",
        attrs: { teamId: _vm.teamId }
      }),
      _c("capability-label", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "capabilityLabel",
            expression: "activeIndex == 'capabilityLabel'"
          }
        ],
        ref: "capabilityLabel",
        attrs: { teamId: _vm.teamId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }